import NewDpcPi from "./NewDpcPi";
import NewDpcFc from "./NewDpcFc";
import Fifpl from "./Fifpl";
import { Typography } from "@mui/material";
import Standard from "./Standard";
import Fafpm from "./Fafpm";
import Free from "./Free";
import Opco from "./Opco";
import useProducts from "../utils/useProducts";
import Loader from "../../Tools/Loader";
import useCart from "../utils/useCart";
import Conflict from "./Conflict";
import useCourse from "../utils/useCourse";
import Etudiant from "./Etudiant";
import { txt } from "../../../services/translation";
import LearnyDaysAlert from "./LearnyDaysAlert";

export default function Products(){

    const { data, isSuccess, isLoading } = useProducts()

    const { cart } = useCart()

    const course = useCourse()

    return (cart.category && cart.status) && <>

        <Typography variant="h5" align="center">{txt('selectFinancing')}</Typography>

        <Conflict />

        {isLoading &&

            <Loader />
        }

        <LearnyDaysAlert />

        {isSuccess &&

            <div className="apply-options">

                {course?.free && 
                    <Free />
                }

                {!course?.free && <>

                    <NewDpcPi 
                        product={data.find(p => p.variant.id === 'dpc-pi')}
                    />

                    <NewDpcFc 
                        product={data.find(p => p.variant.id === 'dpc')}
                    />

                    <Fifpl 
                        product={data.find(p => p.variant.id === 'fifpl')}
                    />

                    <Fafpm 
                        product={data.find(p => p.variant.id === 'fafpm')}
                    />

                    <Opco
                        product={data.find(p => p.variant.id === 'opco')}
                    />

                    <Etudiant
                        product={data.find(p => p.variant.id === 'etudiant')}
                    />

                    <Standard
                        product={data.find(p => p.variant.id === 'standard' && p.price > 0)}
                    />

                </>}

            </div>
        }

    </>
}